export const statCardTitleStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const statCardCountStyle = (colorCode: string) => {
  return {
    color: colorCode,
    fontSize: "80px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
};
